import React from 'react';
import { hasValue } from 'swipeclock-frontend';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import PropTypes from 'prop-types';
import SwipeclockLoader from 'components/SwipeclockLoader/SwipeclockLoader';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Progress({ delay, message }) {
  // Delay showing the loader if it's less than about 1 sec
  return (
    <Rectangle>
      <Fade
        in
        style={{
          transitionDelay: delay ? '800ms' : '0ms',
        }}
        unmountOnExit
      >
        <div>
          <Stack gap={4} alignItems="center">
            {hasValue(message) && (
              <Typography variant="h4" component="p">
                {message}
              </Typography>
            )}
            <SwipeclockLoader />
          </Stack>
        </div>
      </Fade>
    </Rectangle>
  );
}

Progress.propTypes = {
  delay: PropTypes.bool,
  message: PropTypes.string,
};

const Rectangle = styled(Box)(() => ({
  width: '100%',
  height: '30svh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
